import {FileGranuleAttributes} from 'shared/models/granule/file-granule.attributes';
import {FormatEntityAttributes} from 'shared/models/granule/format-entity.attributes';
import {GranuleMetadata} from 'shared/models/granule/granule.metadata';
import {InfoGranuleInterface} from 'shared/models/granule/info-granule.interface';
import {Usage} from 'shared/models/granule/usage';

export enum LessonStates {
    archived = 'archived',
    published = 'published',
    draft = 'draft',
}
export enum ActionForLesson {
    archive = 'archive',
    unarchive = 'unarchive',
    publish = 'publish',
    draft = 'draft',
}

export interface GranuleEntityAttributesInterface<R> {
    allow_user_review?: boolean,
    archived: boolean,
    bookmarks: boolean,
    changed: string,
    consulted: boolean,
    created: string,
    duplicationCount?: number,
    evaluation?: boolean,
    file: undefined | FileGranuleAttributes,
    format: FormatEntityAttributes,
    id: string | number,
    infos: InfoGranuleInterface,
    lesson_id: string | number,
    level: unknown,
    locked: "0" | "1",
    metadatas: GranuleMetadata,
    model: boolean,
    'multi_step': boolean,
    original: string,
    owner: string | number
    "owner-name": string,
    "owner-role": string,
    promoted?: unknown,
    // 0 - not published, 1 - published
    published: 0 | 1,
    reference: R,
    requirementsAccess?: undefined | { access: unknown },
    shared: boolean,
    theme: unknown[],
    usage: Usage[],
    weight?: unknown[],
    action?: ActionForLesson,
    parcoursState?: LessonStates,
}

